var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "TableList",
        {
          attrs: {
            columns: _vm.tabPaneConfig[_vm.tabKey - 1].columns,
            tableData: _vm.tabPaneConfig[_vm.tabKey - 1].tableData,
            loading: _vm.tabPaneConfig[_vm.tabKey - 1].loading,
            scroll: false,
            pagination: _vm.tabPaneConfig[_vm.tabKey - 1].pagination,
          },
          on: { change: _vm.handleTableChange },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ record }) {
                return [
                  _c(
                    "div",
                    { staticClass: "action-detail" },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.disposeRemind(record)
                            },
                          },
                        },
                        [_vm._v("处理提醒")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.viewArchives(record, "view")
                            },
                          },
                        },
                        [_vm._v("查看档案")]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "div",
            {
              staticClass: "query-area",
              attrs: { slot: "queryArea" },
              slot: "queryArea",
            },
            [
              _c(
                "div",
                [
                  _c("j-dict-select-tag", {
                    staticStyle: { width: "170px", "margin-right": "15px" },
                    attrs: {
                      placeholder: "请选择班级",
                      identityGet: "classDict",
                      async: true,
                      isShowEmpty: false,
                    },
                    model: {
                      value: _vm.queryParam.classId,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "classId", $$v)
                      },
                      expression: "queryParam.classId",
                    },
                  }),
                  _c("a-range-picker", {
                    staticClass: "search-space",
                    staticStyle: { width: "240px" },
                    model: {
                      value: _vm.dateRange,
                      callback: function ($$v) {
                        _vm.dateRange = $$v
                      },
                      expression: "dateRange",
                    },
                  }),
                  _c("j-dict-select-tag", {
                    staticClass: "search-space",
                    attrs: { placeholder: "提醒等级", dictCode: "care_list" },
                    model: {
                      value: _vm.queryParam.careList,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "careList", $$v)
                      },
                      expression: "queryParam.careList",
                    },
                  }),
                  _c("a-select", {
                    staticStyle: { width: "170px", "margin-right": "15px" },
                    attrs: {
                      placeholder: "请选择状态",
                      options: _vm.followOptions,
                      allowClear: "",
                    },
                    model: {
                      value: _vm.queryParam.dealStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "dealStatus", $$v)
                      },
                      expression: "queryParam.dealStatus",
                    },
                  }),
                  _c("a-input-search", {
                    staticClass: "search-space",
                    staticStyle: { width: "170px" },
                    attrs: { placeholder: "请输入学生名字" },
                    on: { change: _vm.searchName },
                    model: {
                      value: _vm.queryParam.studentName,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "studentName", $$v)
                      },
                      expression: "queryParam.studentName",
                    },
                  }),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.queryTable },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-right": "15px" },
                      attrs: { type: "primary", icon: "download" },
                      on: {
                        click: function ($event) {
                          return _vm.handleExportXls("心情提醒")
                        },
                      },
                    },
                    [_vm._v("\n          导出\n        ")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c("InformationNote", { ref: "informationNoteRef" }),
      _c("DisposeRemind", { ref: "disposeRemindRef" }),
      _c("ReservePsychologyTeacher", { ref: "reservePsychologyTeaRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }